import { render, staticRenderFns } from "./TemplateParser.vue?vue&type=template&id=7dd22fb8&scoped=true&"
import script from "./TemplateParser.vue?vue&type=script&lang=js&"
export * from "./TemplateParser.vue?vue&type=script&lang=js&"
import style0 from "./TemplateParser.vue?vue&type=style&index=0&id=7dd22fb8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dd22fb8",
  null
  
)

export default component.exports